import React from 'react';
import { Link } from 'react-router-dom';
import FA from 'react-fontawesome';
import StackBadges from './StackBadges';

function ProjectDetail({ project }) {
  const badges = project.tech || project.stack;
  const screenshots = project.screenshots || [];
  const isSample = project.screenshotLayout === 'samples';

  return (
    <article className="project-detail">
      <div className="container">
        <Link className="back-link" to="/">
          ← Back to projects
        </Link>

        <header className="project-detail-header">
          <div className="project-detail-title-row">
            <div className="project-detail-heading">
              {project.icon && (
                <img
                  className="project-app-icon"
                  src={project.icon}
                  alt=""
                  width={64}
                  height={64}
                />
              )}
              <div>
                <p className="project-category">{project.category}</p>
                <h1 className="title project-detail-title">{project.title}</h1>
                {project.subtitle && <p className="project-subtitle">{project.subtitle}</p>}
              </div>
            </div>
            <span className={`project-badge project-badge-${project.statusVariant}`}>
              {project.status}
            </span>
          </div>
          <StackBadges items={badges} />
        </header>

        {project.hardPart && (
          <p className="project-hard-part project-hard-part-detail">{project.hardPart}</p>
        )}

        {screenshots.length > 0 && (
          <div
            className={`project-screenshot-gallery${
              isSample ? ' project-screenshot-gallery-samples' : ''
            }`}
            aria-label={isSample ? 'Output samples' : 'App screenshots'}
          >
            <div className="project-screenshot-track">
              {screenshots.map((src, index) => (
                <figure
                  key={src}
                  className={`project-shot${isSample ? ' project-shot-sample' : ''}`}
                >
                  <img
                    src={src}
                    alt={`${project.title} ${isSample ? 'sample' : 'screenshot'} ${index + 1}`}
                    loading={index === 0 ? 'eager' : 'lazy'}
                    width={isSample ? 280 : 210}
                    height={isSample ? (index === 0 ? 280 : 420) : 454}
                  />
                </figure>
              ))}
            </div>
          </div>
        )}

        {project.body && (
          <div className="project-body">
            <p>{project.body}</p>
          </div>
        )}

        {project.links && project.links.length > 0 && (
          <div className="project-links">
            <div className="project-store-links">
              {project.links.map((link) => (
                <a
                  key={link.label}
                  className="button is-rounded is-small btn-ghost"
                  href={link.href}
                  target="_blank"
                  rel="noreferrer"
                >
                  {link.icon && (
                    <span className="icon is-small">
                      <FA name={link.icon} />
                    </span>
                  )}
                  <span>{link.label}</span>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </article>
  );
}

export default ProjectDetail;
